import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators, FormArray } from '@angular/forms';
import { PurchaseOrder } from 'app/shared/types/purchase-order';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PurchaseOrderService } from 'app/shared/services/purchase-order.service';
import { DialogService } from 'app/shared/services/dialog.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { ItemService } from 'app/shared/services/item.service';
import { SupplierService} from 'app/shared/services/supplier.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs'
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { CanvasImageService} from 'app/shared/services/canvas-image.service';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;

  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

  filteredSupplierList: Observable<any[]>;
	supplierList : any[];

  companyData : any;
  logo :any;

  purchaseOrder:PurchaseOrder;
  purchaseOrderData = [];
  purchaseOrderForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isShowAttachBtn: boolean=false;
  isHideBtn: boolean= false;
  isBtnDisabled : boolean= false;
  bsClassToShow : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  validationMessages = {
    'poNo': { 'required': 'Purchase order number is required' },
    'poDate': { 'required': 'Date is required' },
    'supId': { 'required': 'Supplier Id  is required' }, 
    'supName': {'required': 'Supplier name is required' },
    'address': {'required': 'Address is required' },
    'deliverTo': {'required': 'Delivery address is required' },
  };

  formErrors = {
    'poNo': "",
    'poDate': "",
    'supId': "",
    'supName': "",
    'address': "",
    'deliverTo': "",
  };



  constructor(private fb: FormBuilder,
    private purchaseOrderService: PurchaseOrderService,
    private authService: AuthService,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private itemService : ItemService,
    private route : ActivatedRoute,
    private router : Router, 
    private supplierService : SupplierService,
    private companyProfileService: CompanyProfileService,
    private canvasImageService  : CanvasImageService,
    private fileUploadService:FileUploadService,
    private themeService: NbThemeService,
    private decimalPipe: DecimalPipe )
  {
    this.datepickerConfig = Object.assign({},
      {   
        showWeekNumbers:false,
        dateInputFormat : 'YYYY-MM-DD'
      });



  }

ngOnInit() {

  this.initPOType();
  this.initFormFields();
  this.getSupplierList();
  this.getItemList();
  this.getControlPermissions();

  this.isBtnDisabled = true;
  this.viewPOById();
  this.disableForm();
  this.getCompanyDetails();

  this.autoCompleteSupplier();

  this.purchaseOrderForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.purchaseOrderForm);
    });

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}// end oninit

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='PO'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

loadLogo(){
    
  if(this.companyData.length===1){
    if(this.companyData[0].Logo){
      let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
      const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
        return data + String.fromCharCode(byte);
      },'');
      let base64String = btoa(STRING_CHAR);
      this.logo = 'data:image/jpeg;base64,' + base64String;
     }else{
      this.logo =null;
     }

     if(this.companyData[0].DigitalSignature){
      let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
      const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
        return data + String.fromCharCode(byte);
      },'');
      let base64String = btoa(STRING_CHAR);
      //this.signature = 'data:image/jpeg;base64,' + base64String;
     }else{
      //this.signature =null;
     }

  } 

 
}


getCompanyDetails(){

  this.companyProfileService.getCompanyDetails()
  .subscribe(
    (data) =>{         
            this.companyData = data;
            this.loadLogo();
              },
    (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
    }
  );

}

autoComplete(index: number){
  this.filteredOptions[index] =this.getPOItems.at(index).get('itemCode').valueChanges
  .pipe(
    startWith(''),
      map(value => this._filter(value))
  );

}

autoCompleteSupplier(){
    this.filteredSupplierList = this.purchaseOrderForm.get('supName').valueChanges
    .pipe(
      startWith(''),
      map(value => this._filterSupplier(value))
    ); 
}

private _filter(itemCode: string): any[] {
  if(itemCode){
  const filterValue = itemCode.toLowerCase();
  return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
  }
}

private _filterSupplier(supName: string): any[] {
  if(supName){
     const filterValue = supName.toLowerCase();
     return this.supplierList.filter(option => option.SupName.toLowerCase().indexOf(filterValue) === 0);
  }
}

getItemData(i){
  var filteredData;
  var value  = this.getPOItems.at(i).get('itemCode').value;
  if(value){
  filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
  if(filteredData.length ===1){
      this.getPOItems.at(i).patchValue({ 
        description : filteredData[0].Description,
        unitPrice : filteredData[0].UnitCost,
        qty :'1.00',
        unit :'', 
        amount : filteredData[0].UnitCost,
      });     
  }else{
    this.getPOItems.at(i).patchValue({ 
      description : '',
      unitPrice : '',
      qty :'',     
      unit :'',  
      amount : '',
    });     

  }
}
}

   
getSupplierDetails(){      
var filteredData;
var supName = this.purchaseOrderForm.value.supName;
if(supName){
filteredData = this.supplierList.filter(data =>data.SupName.toLowerCase()===supName.toLowerCase());
 if(filteredData.length ===1){
   this.purchaseOrderForm.patchValue({
     supId : filteredData[0].SupId,
     address :filteredData[0].Address,
   });
 } else{
  this.purchaseOrderForm.patchValue({
    supId : null,
    address :null,
  });
 }
}
}




getItemList(){
this.itemService.getAll()
.subscribe(
  (data) => {
            this.itemList = data                
            },
 (err) => 
          {
            if(err instanceof HttpErrorResponse){                 
              if(err.status == 401){
                this.router.navigate(['/login']);
              }
            }
            console.log(err);
          });  
 
}

getSupplierList(){
this.supplierService.getAll()
 .subscribe(
    (data) => {
                this.supplierList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
              },
   (err) => 
            {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            });  
   
    }





initPOType() : void{

  this.purchaseOrder = {
    poNo: '',
    poDate: '',
    supId: '',
    supName: '',
    address: '',
    deliverTo: '',
    itemCode: '',
    description: '',
    unitPrice: 0.00,
    qty: 0.00,
    unit: '',
    amount: 0.00,
    subTotal: 0.00,
    vat: 0.00,
    grandTotal: 0.00,
    remarks : '',
    status : '',
    createdBy : '',

  };
}

initFormFields() : void{
  this.purchaseOrderForm = this.fb.group({
    poNo : ['',Validators.required],
    poDate : ['',Validators.required],
    supId : ['',Validators.required],
    supName : [null,Validators.required],
    address : ['',Validators.required],
    deliverTo : [''],
    remarks : [''],
    POItems : this.fb.array([this.addPOItem()]), 
     
  });
  this.autoComplete(0);

}


newButtonClick(): void {
  this.isfieldReadOnly  = false;
  this.isBtnDisabled = false;
  this.isHideBtn = false;
  this.isShowAttachBtn=false;
  this.purchaseOrderForm.reset();
  this.resetOtherControls();
  this.enableForm();
  this.getMaxId();
  this.addItemButtonClick();
  this.purchaseOrderForm.patchValue({
    poDate:  this.defaultDate,
    deliverTo :  this.companyData[0].CompanyName +'\n'+this.companyData[0].DeliveryAddress
  });

   
 }

 getMaxId(){
  var poNo = 0;
  var poNoPrefixZero  : String;

  this.purchaseOrderService.getMaxId()
  .subscribe(
    (res) => {
        poNo = Number(res[0].PONo) + 1;
        poNoPrefixZero = poNo.toString().padStart(6,'0');       
        this.purchaseOrderForm.patchValue({
          poNo : "PO" + poNoPrefixZero
        });
       
    },        
    (err) =>  {
            if(err instanceof HttpErrorResponse){                 
              if(err.status == 401){
                this.router.navigate(['/login']);
              }
            }
            console.log(err);
        }, 
    )

 }

 addPOItem() : FormGroup{
  return this.fb.group({
    itemCode : ['',Validators.required],
    description : ['',Validators.required],
    unitPrice :['',Validators.required],
    qty : ['',Validators.required],
    unit : [''],
    amount : ['',Validators.required],

   });
  
 }



 get getPOItems(){
    return this.purchaseOrderForm.get('POItems') as FormArray;
 }

    addItemButtonClick() : void {
      this.getPOItems.push(this.addPOItem());
      this.autoComplete(this.getPOItems.length-1);
      this.updateBillTotal();
        
    }

    removeItemButtonClick(itemIndex : number) : void{
      this.getPOItems.removeAt(itemIndex);
      this.filteredOptions.splice(itemIndex, 1);
      this.updateBillTotal()
    }

  resetOtherControls() : void{
      this.getPOItems.clear();
      
      this.purchaseOrder.subTotal = 0.00;
      this.purchaseOrder.vat = 0.00;
      this.purchaseOrder.grandTotal = 0.00;
      this.bsClassToShow = false;
  }



  calEachItemAmount(i){
    var unitPrice : number;
    var qty : number;
    var amount : number;
    var itemCode = this.getPOItems.at(i).get('itemCode').value
    if(itemCode){
    unitPrice = parseFloat(this.getPOItems.at(i).get('unitPrice').value);
    qty =  parseFloat(this.getPOItems.at(i).get('qty').value);
    amount = parseFloat((unitPrice * qty).toFixed(2));
    this.getPOItems.at(i).patchValue({amount : amount.toString() });
    }

    this.updateBillTotal();
  }

updateBillTotal(){
  this.purchaseOrder.subTotal = this.getPOItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
  this.purchaseOrder.vat = 0.00;
  this.purchaseOrder.grandTotal = this.purchaseOrder.subTotal + this.purchaseOrder.vat;   
}


mapFormValuesToModel(){
  this.purchaseOrderData =[];
  var result = [];
 
  for(let i=0; i < this.getPOItems.length; i++){

  this.purchaseOrder.poNo=this.purchaseOrderForm.value.poNo;
  this.purchaseOrder.poDate=this.purchaseOrderForm.value.poDate;
  this.purchaseOrder.supId=this.purchaseOrderForm.value.supId;
  this.purchaseOrder.supName=this.purchaseOrderForm.value.supName;
  this.purchaseOrder.address = this.purchaseOrderForm.value.address;
  this.purchaseOrder.deliverTo = this.purchaseOrderForm.value.deliverTo;
  this.purchaseOrder.itemCode = this.getPOItems.value[i].itemCode
  this.purchaseOrder.description=this.getPOItems.value[i].description;
  this.purchaseOrder.unitPrice=this.getPOItems.value[i].unitPrice;
  this.purchaseOrder.qty=this.getPOItems.value[i].qty;
  this.purchaseOrder.unit=this.getPOItems.value[i].unit;
  this.purchaseOrder.amount=this.getPOItems.value[i].amount;
  this.purchaseOrder.subTotal=this.purchaseOrder.subTotal;
  this.purchaseOrder.vat =this.purchaseOrder.vat;
  this.purchaseOrder.grandTotal=this.purchaseOrder.subTotal +this.purchaseOrder.vat;
  this.purchaseOrder.remarks=this.purchaseOrderForm.value.remarks;
  this.purchaseOrder.status='posted';
  this.purchaseOrder.createdBy =this.authService.getUserLoggedIn();
  
  this.purchaseOrderData.push(
    this.purchaseOrder.poNo,
    this.purchaseOrder.poDate,
    this.purchaseOrder.supId,
    this.purchaseOrder.supName,
    this.purchaseOrder.address,
    this.purchaseOrder.deliverTo,
        
    this.purchaseOrder.itemCode,
    this.purchaseOrder.description,
    this.purchaseOrder.unitPrice,
    this.purchaseOrder.qty,
    this.purchaseOrder.unit,
    this.purchaseOrder.amount,

    this.purchaseOrder.subTotal,
    this.purchaseOrder.vat,
    this.purchaseOrder.grandTotal,
    this.purchaseOrder.remarks,
    this.purchaseOrder.status,
    this.purchaseOrder.createdBy,

    );

  }

  while(this.purchaseOrderData.length){
    result.push(this.purchaseOrderData.splice(0,18));
  }

  return result;

}

 
saveButtonClick(): void {
  this.logValidationErrors(this.purchaseOrderForm,true);
  var data = this.mapFormValuesToModel();

  if(this.isFilledFromFields()){
      this.showProcessingIndicator = true;
        this.purchaseOrderService.addPurchaseOrder(data)
        .subscribe(
          (res) =>{
            if(res.success === 0){
              this.purchaseOrderForm.patchValue({
              poNo : res.autoId
              });
            this.saveButtonClick();
            this.showProcessingIndicator = false; 
            
            }else if(res.success === 1){
              console.log(res);
              this.toastr.success('Purchase order created successfully','Success');
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isShowAttachBtn = true;
              this.isHideBtn = true;
              this.disableForm(); 
              this.showProcessingIndicator = false;   
           }   


          },
          (err) =>{
            this.toastr.error('Failed to add purchase order','Failure'); 
            this.showProcessingIndicator = false;   
            if(err instanceof HttpErrorResponse){                 
              if(err.status == 401){
                this.router.navigate(['/login']);
              }
            }
            console.log(err);
          }
        )
      } 

  else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;                                                                                                                                                                                                   
      } 
 }



 enableForm():void{
  Object.keys(this.purchaseOrderForm.controls).forEach(key => {
    this.purchaseOrderForm.controls[key].enable();
    //console.log("Enable "+key)     
  });

}


disableForm():void{
  Object.keys(this.purchaseOrderForm.controls).forEach(key => {
    this.purchaseOrderForm.controls[key].disable();
   // console.log("disable "+key);
  });

}

logValidationErrors(group: FormGroup = this.purchaseOrderForm,isDirty :boolean=false): void {
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    this.formErrors[key] = '';
    if(isDirty)
    {
      this.enableForm();
      this.purchaseOrderForm.controls[key].markAsTouched();
    }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } 
  });
}

isFilledFromFields() : boolean {
  (<FormArray>this.purchaseOrderForm.get('POItems')).controls.forEach((group: FormGroup) => {
    (<any>Object).values(group.controls).forEach((control: FormControl) => { 
        control.markAsTouched();
    }) 
  });

  var value = this.purchaseOrderForm.value.supId;
  if(!value){
    this.purchaseOrderForm.patchValue({ supId :  null,supName :  null, address : null });    
  }

  for (var key in this.formErrors) {
    if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
      }
      if(this.getPOItems.length==0 || this.purchaseOrderForm.get('POItems').invalid){
        return false;
        }
      return true;
}





  viewPOById(){
      var hasPoNo;
      var poNo;

      hasPoNo=this.route.snapshot.queryParamMap.has('poNo');
       
        if(hasPoNo){
          poNo = this.route.snapshot.queryParamMap.get('poNo')
          this.purchaseOrderService.getPurchaseOrder(poNo)
          .subscribe(
            (data) => {
                      if(data){
                        this.patchValuesToForm(data); 
                        this.disableForm(); 
                        this.isfieldReadOnly = true;
                        this.isBtnDisabled = true;  
                        this.isShowAttachBtn = true;
                        this.isHideBtn = true;
                        this.bsClassToShow = true;                     
                       }
                      },
          (err) => 
                    {
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    });
    }

  }

patchValuesToForm(data){
this.purchaseOrderForm.patchValue({  
  poNo : data[0].PONo,
  poDate : moment(data[0].Date).format("YYYY-MM-DD"),
  supId : data[0].SupId,
  supName : data[0].SupName,
  address : data[0].Address,
  deliverTo : data[0].DeliverTo,
  remarks : data[0].Remarks,

});

this.purchaseOrderForm.setControl('POItems',this.setPOItems(data));
this.purchaseOrder.subTotal= data[0].SubTotal;
this.purchaseOrder.vat = data[0].Vat;
this.purchaseOrder.grandTotal = data[0].GrandTotal,

this.purchaseOrder.status = data[0].Status;

}


setPOItems(data) : FormArray{
  const POItemArray = new FormArray([]);
  for(let i =0; i < data.length;i++){ 
    POItemArray.push(this.fb.group({
      itemCode : [data[i].ItemCode],
      description : [data[i].Description],
      unitPrice : [data[i].UnitPrice],
      qty : [data[i].Qty],
      unit : [data[i].UOM],
      amount : [data[i].Amount],    
    }));
  }
  return POItemArray;
}

attachFileButtonClick(){
  this.fileUploadService.refNo = this.purchaseOrderForm.value.poNo;
   const dialogConfig = new MatDialogConfig();
   dialogConfig.disableClose = true;
   dialogConfig.autoFocus = true;
   dialogConfig.width = "75%";
   this.dialogService.openDialog(FileUploadComponent,dialogConfig);
      
  }

   savePDF(action){
                                                                                                            
    const documentDefinition = { 
      pageSize: 'A4',
      pageOrientation: 'portrait',     

      content: [ 

          
        {
          columns : [ 
            
                  { image:this.logo,            
                    width: 100,
                    height: 100,
                    fontSize: 28,
                    margin: [0, 0, 0, 15],
                  },

                 { width: '*', text: '' },
                [                                       
                 {
                  text: 'Purchase Order',
                  color: '#333333',
                  width: 140,   
                  fontSize: 30,
                  bold: true,
                  alignment: 'right',
                  margin: [0, 0, 0, 15],
                },
                { text: `PO. No : ${this.purchaseOrderForm.value.poNo}`, alignment: 'right' },  
                { text: `PO. Date : ${moment(this.purchaseOrderForm.value.poDate).format("YYYY-MM-DD")}`,alignment: 'right' } 
               ] 
                      
          ]
  
        },

        {
          columns : [
            [
              { text: 'Supplier Details :' },  
              { text: this.purchaseOrderForm.value.supName,  bold: true },                                           
              { text: this.purchaseOrderForm.value.address },  
 
            ],
            [
              { text: 'Deliver To :',margin: [40, 0, 0, 0] },  
              { text: this.companyData[0].CompanyName, bold:true,margin: [40, 0, 0, 0] },  
              { text: this.companyData[0].DeliveryAddress,margin: [40, 0, 0, 0]},  

            ],
          ]
        },

        '\n\n',
                           
        {  
          layout: {
            defaultBorder: false,
            hLineWidth: function(i, node) {
              return 1;
            },
            vLineWidth: function(i, node) {
              return 1;
            },
            hLineColor: function(i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor: function(i, node) {
              return '#eaeaea';
            },
            hLineStyle: function(i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function(i, node) {
              return 10;
            },
            paddingRight: function(i, node) {
              return 10;
            },
            paddingTop: function(i, node) {
              return 2;
            },
            paddingBottom: function(i, node) {
              return 2;
            },
            fillColor: function(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {  
              headerRows: 1,  
              widths: ['*', 'auto', 'auto','auto', 'auto'],  
              body: [  
                [
                 { text: 'Description',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'UnitPrice',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Qty',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Unit',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Amount',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                ...this.getPOItems.value.map(p => ([{ text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5]}, {text : this.transformNumberFormat(p.unitPrice), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right' }, { text : this.transformNumberFormat(p.qty), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right'  },{ text :p.unit, border: [false, false, false, true],  margin: [0, 5, 0, 5]},{ text: this.transformNumberFormat(p.amount), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right' }])),               
              ]           
        }       
      },

      '\n',
      '\n\n',
      {
        columns : [
            
               {},
                       
              { 
                layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  return '#eaeaea';
                },
                vLineColor: function(i, node) {
                  return '#eaeaea';
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 3;
                },
                paddingBottom: function(i, node) {
                  return 3;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return '#fff';
                },
              },
                width: 'auto',
                table: {
                headerRows: 1,
                widths: ['auto', 'auto'],
                    body: [
                    [
                      {
                        text: 'Total',
                        border: [false, true, false, true],
                        alignment: 'right',
                        margin: [0, 5, 0, 5],
                      },
                      {                     
                        text: this.transformNumberFormat(this.purchaseOrder.grandTotal),
                        border: [false, true, false, true],
                        alignment: 'right',
                        fillColor: '#f5f5f5',
                        margin: [0, 5, 0, 5],
                      },
                    ],                     
                  ],
                },
              },         
        ]

      },
      [
        '\n',
        '\n\n',
        '\n\n',
        '\n',
        {alignment:'right',canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 150, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
        '\n',
        {text: 'Signature', alignment: 'right', margin: [0, 5, 45, 5]},

      ],  

      '\n','\n\n',             
      {
       text: 'Thank You For Your Business!',
       width: '*', 
       alignment: 'center',  
       italics: true, 
      }

      ],
      styles: {  
        reportHeader: {  
            bold: true,  
            decoration: 'underline',  
            fontSize: 14,  
            margin: [0, 15, 0, 15],
            alignment: 'center',             
        }  
      }  
     };

      if(action==='open'){    
            pdfMake.createPdf(documentDefinition).open();  
        }else if(action === 'print'){    
            pdfMake.createPdf(documentDefinition).print();          
        }
        else if(action === 'download'){    
          pdfMake.createPdf(documentDefinition).download(`Purchase Order-${this.purchaseOrderForm.value.poNo}`);     
      }
   }


   transformNumberFormat(number) {
    return this.decimalPipe.transform(number,'1.2-2');
   }


}
